<template>
  <section class="">
    <h3 class="">
      <strong>{{ $t("product-match-someone-else") }}</strong>
    </h3>

    <b-tabs class="border-0 bg-white px-4 full-width">
      <b-tab
        v-if="friendsVerification"
        class="padding-none border-0 bg-white overflow-auto "
        active
      >
        <template class="bg-white padding-none w-50" v-slot:title>
          <p class="mb-0 mt-0 bg-white">
            <strong>{{ $t("product-others-friends-family") }}</strong>
          </p>
        </template>
        <div class="" style="max-height: 400px">
          <div
            class="mt-4 "
            v-for="contact in contacts"
            v-bind:key="contact.id"
          >
            <p v-bind:class="{ notActive: !contact.active_bodyprint }">
              <input
                :disabled="!contact.active_bodyprint"
                type="radio"
                v-bind:value="contact"
                v-bind:id="contact.id"
                v-model="picked"
                name="radio-group"
              />
              <label class="pl-5" v-bind:for="contact.id"
                >{{ contact.firstname }} {{ contact.lastname }}</label
              >
            </p>
          </div>
        </div>
      </b-tab>
      <b-tab
        v-if="groupsVerification && GroupsEnabled"
        class="padding-none border-0 bg-white overflow-auto"
      >
        <template class="bg-white padding-none w-50" v-slot:title>
          <p class="mb-0 mt-0">
            <strong>{{ $t("groups") }}</strong>
          </p>
        </template>
        <div class="mt-4" v-for="group in groups" v-bind:key="group._id">
          <p class="mb-0" v-if="group.has_members && group.state === 'owner'">
            <input
              type="radio"
              v-bind:value="group"
              v-bind:id="group._id"
              v-model="picked"
              name="radio-group"
            />
            <label class="pl-5" v-bind:for="group._id">{{ group.name }}</label>
          </p>
        </div>
      </b-tab>
    </b-tabs>

    <div class="bg-white border-top pt-5 px-4">
      <b-button
        class="rounded py-2 w-100"
        @click="startMatching()"
        block
        variant="black"
        :disabled="!picked"
      >
        <b>{{ $t("product-others-get-size") }}</b>
      </b-button>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "others",
  data() {
    return {
      picked: false,
      from: null
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.from = from;
    });
  },
  computed: {
    ...mapGetters({
      contacts: "contacts/getContacts",
      groups: "groups/getGroups",
      GroupsEnabled: "pageParams/getGroupsEnabled"
    }),
    groupsVerification() {
      return (
        this.groups.some(group => group["has_members"] === true) &&
        this.groups.some(group => group["state"] === "owner")
      );
    },
    friendsVerification() {
      return this.contacts.some(friend => friend["active_bodyprint"] != null);
    }
  },
  methods: {
    pushUrl() {
      if (this.from.name === "match-group") {
        this.$router.push({ name: "match-done-group" });
      } else {
        this.$router.push({ name: "match-done" });
      }
    },
    startMatching() {
      if (this.picked.has_members) {
        this.$store.commit("application/SET_MATCHABLE", this.picked._id);
        this.$store.commit("application/SET_NAME", this.picked.name);
        this.$router.push({ name: "match-group" });
      } else {
        this.$store.commit("application/SET_MATCHABLE", this.picked.user);
        this.$store.commit("application/SET_NAME", this.picked.firstname);
        this.$router.push({ name: "match" });
      }
    }
  }
};
</script>
<style>
.full-width .card-header-tabs {
  margin-right: -21px;
  margin-left: -21px;
}

.full-width .nav-tabs .nav-item {
  margin-bottom: -1px;
  flex-grow: 1;
  text-align: center;
  border-bottom-color: #232323;
}
.nav-tabs .nav-link:hover,
.nav-tabs .nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #444444;
  border-bottom: 2px solid #444444;
}

.nav-tabs .nav-link {
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
  border: none;
  background: white;
  border-bottom: 2px solid #aaaaaa;
  color: #aaaaaa;
}

[type="radio"]:checked,
[type="radio"]:not(:checked) {
  position: absolute;
  left: -9999px;
}

[type="radio"]:not(:checked) + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: black;
  border-radius: 5px;
  border: 2px solid #ddd;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
}

[type="radio"]:checked + label {
  position: relative;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  color: black;
  border-radius: 5px;
  border: 2px solid black;
  width: 100%;
  padding-top: 15px;
  padding-bottom: 15px;
}

[type="radio"]:not(:checked) + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  width: 22px;
  height: 22px;
  border: 2px solid #ddd;
  border-radius: 100%;
  background: #fff;
}

[type="radio"]:checked + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  margin-top: 15px;
  margin-left: 15px;
  width: 22px;
  height: 22px;
  border: 2px solid black;
  border-radius: 100%;
  background: #fff;
}

[type="radio"]:checked + label:after,
[type="radio"]:not(:checked) + label:after {
  content: "";
  margin-top: 16px;
  margin-left: 16px;
  width: 12px;
  height: 12px;
  background: black;
  position: absolute;
  top: 4px;
  left: 4px;
  border-radius: 100%;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
[type="radio"]:not(:checked) + label:after {
  opacity: 0;
  -webkit-transform: scale(0);
  transform: scale(0);
}
[type="radio"]:checked + label:after {
  opacity: 1;
  -webkit-transform: scale(1);
  transform: scale(1);
}

.notActive [type="radio"]:not(:checked) + label:before {
  background-color: #ddd;
  cursor: default;
}

.notActive [type="radio"]:not(:checked) + label {
  cursor: default;
}

.back-button {
  cursor: pointer;
  margin-top: 5px;
}

.nav-tabs .nav-link {
  outline: none;
}
</style>
